// ALWAYS SYNC THESE WITH less variables
export const PrimaryColor = '#127ABA';
